/* eslint-disable no-console */
import { useState, useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useApi } from 'hooks/useApi';
import userApi from 'api/user';
import { useLocationList } from 'hooks/useLocationList';
import { RoleEnum } from 'models/constants';

export const useUserCreator = () => {
  const { goBack } = useHistory();
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const {
    globalState,
    dispatchGlobalState,
    error,
    showError,
    isUpdating,
    setIsUpdating,
    handleCreateData,
  } = useApi(userApi, false);
  const {
    locationsData,
    locationListOptions,
    radiologyLocationListOptions,
    surgeryLocationListOptions,
  } = useLocationList();

  const defaultValues = useMemo(
    () => ({
      role: '',
      nameFirst: '',
      nameSecond: '',
      LocationId: '',
      address: '',
      phoneNumber: '',
      email: '',
      password: '',
      status: 'ACTIVE',
    }),
    []
  );

  const {
    register,
    control,
    reset,
    handleSubmit,
    values,
    getValues,
    setValue,
    formState: { errors, isDirty },
    trigger,
    watch,
  } = useForm({
    defaultValues,
  });

  const onSubmit = async requestData => {
    const postData = requestData;
    if (postData?.role === RoleEnum.MASTER_ADMIN) {
      delete postData.LocationId;
      delete postData.phoneNumber;
    }

    if (postData?.role === RoleEnum.IMAGE_ENGINEER) {
      delete postData.LocationId;
    }

    const result = await handleCreateData(postData);
    if (!result) return false;

    dispatchGlobalState({
      type: 'SET_users',
      payload: {},
    });
    goBack();

    return true;
  };

  useEffect(() => {
    reset(defaultValues);
    document.title = 'Create New User';

    return () => {
      dispatchGlobalState({
        type: 'SET_isDataChanged',
        payload: false,
      });
    };
  }, []);

  useEffect(() => {
    if (isDirty !== globalState.isDataChanged) {
      dispatchGlobalState({
        type: 'SET_isDataChanged',
        payload: isDirty,
      });
    }
  }, [isDirty, globalState.isDataChanged]);

  return {
    isUpdating,
    setIsUpdating,
    error,
    showError,
    handleSubmit,
    onSubmit,
    isPasswordVisible,
    setIsPasswordVisible,
    errors,
    isDirty,
    trigger,
    values,
    getValues,
    setValue,
    register,
    reset,
    control,
    watch,
    locationsData,
    locationListOptions,
    radiologyLocationListOptions,
    surgeryLocationListOptions,
    userRole: globalState?.user?.value?.role,
  };
};
